import {BaseActionButton} from './BaseActionButton';

class Delete extends BaseActionButton {
  icon = 'trash';
  tooltip = 'Delete selected nodes';

  disabled = () => {
    const {selection} = this.rackEditorStore;
    return selection.nothingSelected;
  };

  onClick = () => {
    const {rackStore, selection} = this.rackEditorStore;
    const nodes = [...selection.selectedNodesIds];
    selection.clear();
    rackStore.deleteNodes(nodes);
    this.hidePopups(true, true);
  };
}

export {Delete};
